import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";

export default function AddDesigner() {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [viewData, setViewData] = useState(null);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    phone: "",
    profile: "",
  });

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    experience: "",
    experience_year: "",
    experience_month: "",
    skills: [],
    location: "",
    expected_salary: "",
    description: "",
    profile: null,
  });
  const [designers, setDesigners] = useState([]);

  useEffect(() => {
    if (user?.id) {
      fetchDesigners();
    }
  }, [user]);

  const fetchDesigners = async () => {
    try {
      const res = await fetch(`${API.USER_DESIGNERS}&user_id=${user.id}`);
      const data = await res.json();

      setDesigners(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };
  const skillList = ["Malti", "Sequien", "Cording", "Beads", "Chain"];

  /* =========================
     HANDLE INPUT
  ========================= */

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    /* =========================
       PHONE VALIDATION
    ========================= */

    if (name === "phone") {
      if (!/^[0-9]{0,10}$/.test(value)) return;

      if (value.length < 10) {
        setErrors((prev) => ({
          ...prev,
          phone: "Phone must be 10 digits",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          phone: "",
        }));
      }

      setForm({
        ...form,
        [name]: value,
      });

      return;
    }

    /* =========================
       PROFILE IMAGE VALIDATION
    ========================= */

    if (type === "file") {
      const file = e.target.files[0];

      // Required check
      if (!file) {
        setErrors((prev) => ({
          ...prev,
          profile: "Profile image is required",
        }));
        return;
      }

      // Only image check
      if (!file.type.startsWith("image/")) {
        setErrors((prev) => ({
          ...prev,
          profile: "Only image files allowed",
        }));
        return;
      }

      // Max 2MB
      if (file.size > 2 * 1024 * 1024) {
        setErrors((prev) => ({
          ...prev,
          profile: "Max 2MB allowed",
        }));
        return;
      }

      setErrors((prev) => ({
        ...prev,
        profile: "",
      }));

      setForm({
        ...form,
        [name]: file,
      });

      return;
    }

    setForm({
      ...form,
      [name]: value,
    });
  };

  /* =========================
     SKILLS
  ========================= */

  const handleSkillChange = (skill) => {
    setForm((prev) => {
      const isSelected = prev.skills.includes(skill);

      const updatedSkills = isSelected
        ? prev.skills.filter((s) => s !== skill)
        : [...prev.skills, skill];

      return {
        ...prev,
        skills: updatedSkills,
      };
    });
  };

  /* =========================
     SUBMIT
  ========================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    /* =========================
       PHONE VALIDATION
    ========================= */

    if (!form.phone || form.phone.length !== 10) {
      alert("Phone number must be exactly 10 digits");
      return;
    }

    if (errors.phone) {
      alert("Please enter valid phone number");
      return;
    }

    /* =========================
       EXPERIENCE VALIDATION
    ========================= */

    const hasYear = !!form.experience_year;
    const hasMonth = !!form.experience_month;

    if (!hasYear && !hasMonth) {
      alert("Please select at least Years or Months in Experience");
      return;
    }

    /* =========================
       FINAL EXPERIENCE
    ========================= */

    let finalExperience = "";

    if (hasYear && hasMonth) {
      finalExperience = `${form.experience_year} Yrs / ${form.experience_month} Mon`;
    } else if (hasYear) {
      finalExperience = `${form.experience_year} Yrs`;
    } else if (hasMonth) {
      finalExperience = `${form.experience_month} Mon`;
    }

    /* =========================
       PROFILE VALIDATION
    ========================= */

    if (!form.profile) {
      setErrors((prev) => ({
        ...prev,
        profile: "Profile image is required",
      }));
      return;
    }

    /* =========================
       FORM DATA
    ========================= */

    const formData = new FormData();

    formData.append("user_id", user.id);
    formData.append("status", "pending");
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("phone", form.phone);
    formData.append("experience", finalExperience);
    formData.append("skills", form.skills.join(", "));
    formData.append("location", form.location);
    formData.append("expected_salary", form.expected_salary);
    formData.append("profile", form.profile);
    formData.append("description", form.description);

    try {
      const res = await fetch(API.ADD_DESIGNER, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.status) {
        alert(data.message || "Designer Added Successfully");
        fetchDesigners();
        /* =========================
           RESET FORM
        ========================= */

        setForm({
          name: "",
          email: "",
          phone: "",
          experience: "",
          experience_year: "",
          experience_month: "",
          skills: [],
          location: "",
          expected_salary: "",
          description: "",
          profile: null,
        });

        setErrors({
          phone: "",
          profile: "",
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

        /* =========================
           REDIRECT
        ========================= */

        navigate("/admin/pending-designer");
      } else {
        alert(data.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("Server Error");
    }
  };
  /* ================= DELETE ================= */

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this designer?")) return;

    try {
      const formData = new FormData();
      formData.append("id", id);

      await fetch(API.DELETE_DESIGNER, {
        method: "POST",
        body: formData,
      });

      fetchDesigners();
    } catch (error) {
      console.error(error);
    }
  };

  /* ================= UPDATE ================= */

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      formData.append("id", editData.id);
      formData.append("name", editData.name);
      formData.append("email", editData.email);
      formData.append("phone", editData.phone);
      formData.append("experience", editData.experience);
      formData.append("skills", editData.skills);
      formData.append("location", editData.location);
      formData.append("expected_salary", editData.expected_salary);
      formData.append("description", editData.description);

      if (editData.profile instanceof File) {
        formData.append("profile", editData.profile);
      }

      setLoading(true);

      const res = await fetch(API.UPDATE_DESIGNERS, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      setLoading(false);

      if (data.status) {
        alert("Designer Updated Successfully");

        setEditData(null);

        fetchDesigners();
      } else {
        alert(data.message || "Update Failed");
      }
    } catch (error) {
      console.error(error);

      setLoading(false);

      alert("Server Error");
    }
  };
  return (
    <div className=" dashboard-content designer-page">
      <form onSubmit={handleSubmit} className="designer-form">
        <div
          className="border-box"
          style={{
            border: "1px solid #495057 ",
            padding: "35px",
            boxShadow: "inset 0 0 0 1px #495057",
            borderRadius: "5px",
          }}
        >
          <h2 className="machine-title">Add Designer</h2>
          <div className="row g-3">
            {/* Name */}
            <div className="col-md-12">
              <label className="designer-label">Designer Name</label>
              <input
                type="text"
                name="name"
                className="designer-input"
                placeholder="Enter designer name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>

            {/* Mobile */}
            <div className="col-md-12">
              <label className="designer-label">Mobile No</label>

              <input
                type="text"
                name="phone"
                className="designer-input"
                placeholder="Enter phone number"
                value={form.phone}
                onChange={handleChange}
                required
              />

              {errors.phone && <span className="error">{errors.phone}</span>}
            </div>

            {/* Email */}
            <div className="col-md-12">
              <label className="designer-label">Email</label>
              <input
                type="email"
                name="email"
                className="designer-input"
                placeholder="Enter email"
                value={form.email}
                onChange={handleChange}
              />
            </div>

            {/* Profile */}
            <div className="col-md-12">
              <label className="designer-label">Profile Photo</label>

              <input
                type="file"
                name="profile"
                className="designer-input"
                onChange={handleChange}
                ref={fileInputRef}
              />

              {errors.profile && (
                <span className="error">{errors.profile}</span>
              )}
            </div>

            {/* Experience */}
            <div className="col-md-12">
              <label className="designer-label">Experience</label>

              <div className="d-flex gap-2">
                <input
                  type="text"
                  name="experience_year"
                  className="designer-input"
                  placeholder="Years"
                  value={form.experience_year}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    setForm({
                      ...form,
                      experience_year: value,
                    });
                  }}
                />

                <input
                  type="text"
                  name="experience_month"
                  className="designer-input"
                  placeholder="Months"
                  value={form.experience_month}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    setForm({
                      ...form,
                      experience_month: value,
                    });
                  }}
                />
              </div>
            </div>

            {/* Location */}
            <div className="col-md-12">
              <label className="designer-label">Location</label>
              <input
                type="text"
                name="location"
                className="designer-input"
                placeholder="Surat"
                value={form.location}
                onChange={handleChange}
              />
            </div>

            {/* Salary */}
            <div className="col-md-12">
              <label className="designer-label">Salary / Hour</label>
              <input
                type="number"
                name="expected_salary"
                className="designer-input"
                placeholder="700"
                value={form.expected_salary}
                onChange={handleChange}
                required
              />
            </div>

            {/* Skills */}
            {/* <div className="col-md-4">
            <label className="designer-label">Expertise Skills</label>

            <div className="designer-skill-grid">
              {skillList.map((skill) => (
                <div key={skill} className="designer-skill-box">
                  <input
                    type="checkbox"
                    className="designer-checkbox"
                    checked={form.skills.includes(skill)}
                    onChange={() => handleSkillChange(skill)}
                  />

                  <span>{skill}</span>
                </div>
              ))}
            </div>
          </div> */}

            <div className="col-md-12">
              <label className="designer-label">Expertise Skills</label>

              <div className="designer-skills">
                <div className="designer-skill-grid">
                  {skillList.map((skill) => (
                    <div key={skill} className="designer-skill-box">
                      <input
                        type="checkbox"
                        className="designer-checkbox"
                        checked={form.skills.includes(skill)}
                        onChange={() => handleSkillChange(skill)}
                      />

                      <span>{skill}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Description */}
            <div className="col-md-12">
              <label className="designer-label">About Work</label>

              <textarea
                name="description"
                className="designer-input designer-textarea"
                placeholder="Describe your work..."
                value={form.description}
                onChange={handleChange}
              />
            </div>

            {/* Button */}
            <div className="col-12">
              <button type="submit" className="designer-btn">
                <i className="bi bi-person-plus-fill me-2"></i>
                Register Designer
              </button>
            </div>
          </div>
        </div>
      </form>

      {/* DESIGNER CARD GRID */}
      <div className="designs-grid">
        {designers.length > 0 ? (
          designers.map((item) => (
            <div className="design-card" key={item.id}>
              {/* IMAGE */}
              <div className="machine-img-container">
                <img
                  src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                  alt={item.name}
                  onError={(e) =>
                    (e.target.src = "https://via.placeholder.com/300x250")
                  }
                />
              </div>

              {/* BODY */}
              <div className="machine-body">
                <h4 className="machine-name">{item.name}</h4>

                {/* PRICE + CONTACT */}
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <div className="price-block">
                    <span className="currency-symbol">₹</span>

                    <span className="amount">
                      {Number(item.expected_salary).toLocaleString("en-IN")}
                    </span>
                  </div>

                  <button className="contact-btn">
                    <i className="bi bi-telephone-fill me-1"></i>
                    Contact
                  </button>
                </div>

                {/* SKILLS + EXPERIENCE */}
                <div className="spec-row mt-2">
                  <div className="spec-item">
                    <span className="spec-label">Skills:</span>

                    <span className="spec-value">{item.skills || "-"}</span>
                  </div>

                  <div className="spec-item">
                    <span className="spec-label">Exp:</span>

                    <span className="spec-value">{item.experience || "-"}</span>
                  </div>
                </div>

                {/* LOCATION */}
                <div className="location-info">
                  <i className="bi bi-geo-alt-fill"></i>
                  {item.location || "N/A"}
                </div>

                {/* STATUS */}
                <div className="mt-2">
                  <span className={`status ${item.status?.toLowerCase()}`}>
                    {item.status}
                  </span>
                </div>

                {/* ACTION BUTTONS */}
                <div className="machine-actions mt-3">
                  {/* VIEW */}
                  <button
                    className="action-btn view-action"
                    onClick={() => setViewData(item)}
                    title="View"
                  >
                    <i className="bi bi-eye-fill"></i>
                  </button>

                  {/* EDIT */}
                  <button
                    className="action-btn edit-action"
                    onClick={() => setEditData(item)}
                    title="Edit"
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  {/* DELETE */}
                  <button
                    className="action-btn delete-action"
                    onClick={() => handleDelete(item.id)}
                    title="Delete"
                  >
                    <i className="bi bi-trash-fill"></i>
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No Designers Found</p>
        )}
      </div>
      {/* VIEW POPUP */}
      {viewData && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>Designer Details</h3>

              <button
                className="close-icon-btn"
                onClick={() => setViewData(null)}
              >
                ✕
              </button>
            </div>

            <div className="text-center mb-3">
              <img
                src={`${UPLOADS.DESIGNER_IMAGE}${viewData.profile}`}
                alt="profile"
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </div>

            <div className="popup-grid">
              <div>
                <label>Name</label>
                <p>{viewData.name}</p>
              </div>

              <div>
                <label>Email</label>
                <p>{viewData.email}</p>
              </div>

              <div>
                <label>Phone</label>
                <p>{viewData.phone}</p>
              </div>

              <div>
                <label>Experience</label>
                <p>{viewData.experience}</p>
              </div>

              <div>
                <label>Salary</label>
                <p>₹ {viewData.expected_salary}</p>
              </div>

              <div>
                <label>Skills</label>
                <p>{viewData.skills}</p>
              </div>

              <div>
                <label>Location</label>
                <p>{viewData.location}</p>
              </div>
            </div>

            <div className="description-box">
              <label>Description</label>
              <p>{viewData.description}</p>
            </div>
          </div>
        </div>
      )}
      {/* EDIT POPUP */}
      {editData && (
        <div className="popup-overlay">
          <div className="popup-box large-popup">
            <div className="popup-header">
              <h3>Edit Designer</h3>

              <button
                className="close-icon-btn"
                onClick={() => setEditData(null)}
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleUpdate}>
              <div className="popup-grid">
                <div>
                  <label>Name</label>

                  <input
                    type="text"
                    value={editData.name}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        name: e.target.value,
                      })
                    }
                  />
                </div>

                <div>
                  <label>Email</label>

                  <input
                    type="email"
                    value={editData.email}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        email: e.target.value,
                      })
                    }
                  />
                </div>

                <div>
                  <label>Phone</label>

                  <input
                    type="text"
                    value={editData.phone}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        phone: e.target.value,
                      })
                    }
                  />
                </div>

                <div>
                  <label>Experience</label>

                  <input
                    type="text"
                    value={editData.experience}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        experience: e.target.value,
                      })
                    }
                  />
                </div>

                <div>
                  <label>Salary</label>

                  <input
                    type="number"
                    value={editData.expected_salary}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        expected_salary: e.target.value,
                      })
                    }
                  />
                </div>

                <div>
                  <label>Location</label>

                  <input
                    type="text"
                    value={editData.location}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        location: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              {/* SKILLS */}
              <div className="mt-3">
                <label>Skills</label>

                <textarea
                  value={editData.skills}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      skills: e.target.value,
                    })
                  }
                />
              </div>

              {/* DESCRIPTION */}
              <div className="mt-3">
                <label>Description</label>

                <textarea
                  value={editData.description}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      description: e.target.value,
                    })
                  }
                />
              </div>

              {/* IMAGE */}
              <div className="mt-3">
                <label>Profile Image</label>

                <input
                  type="file"
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      profile: e.target.files[0],
                    })
                  }
                />
              </div>

              <div className="mt-4 text-end">
                <button
                  className="designer-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Designer"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
